export const S_N_LANG = 'LANGUAGE'

// Store the json data of the widgets
export const S_N_WIDGET = 'WIDGET'

// Decide whether to auto print on the preview page
export const S_N_PRINT = 'PRINT'
